import { Stack } from "@biom3/react";
import { memo } from "react";

interface ErrorViewProps {
  error: string | null;
}

export const ErrorView = memo<ErrorViewProps>(({ error }) => {
  return (
    <Stack
      direction="column"
      gap="base.spacing.x6"
      justifyContent="center"
      sx={{
        width: "100%",
        mt: "base.spacing.x14",
        height: "100%",
        px: "base.spacing.x6",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {error}
    </Stack>
  );
});

ErrorView.displayName = "ErrorView";
